module.exports = __webpack_public_path__ + "img/bg2.4a1eeb97.png";